<template>
	<sf-modal-layout class="qms-xxl partCkuPrvsPopup" :title="title" :show="show" :closeModal="close">
		<!-- <div class="sf-flex-column h-100"> -->
		<!-- <div class="sf-col sf-col-20">
				<sf-card class="pb-3 border-0 bg-transparent h-100">
					<part-mng-popup-table ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId" />
				</sf-card>
			</div> -->

		<div class="el-dialog__body d-flex w-100 h-100" style="flex-direction: row; overflow-y: hidden">
			<div style="width: 47%">
				<div class="sf-flex-column h-100">
					<div class="sf-col sf-col-5">
						<sf-card class="p-0 card_bg">
							<part-cku-prvs-popup-m-search ref="partCkuPrvsPopupM" :scrId="scrId" :propData="propPartNo" />
						</sf-card>
					</div>
					<div class="sf-col sf-col-20">
						<part-cku-prvs-popup-m-table
							ref="leftTable"
							height="60vh"
							selection
							:scrId="scrId"
							:rows="masterPopupList"
							@Refresh="Refresh"
						/>
					</div>
				</div>
				<!-- <part-cku-prvs-m-popup-table ref="queueTable" height="500px" selection :columns="columns" :scrId="scrId" :rows="queues" /> -->
			</div>

			<!-- 좌, 우 화살표 -->
			<div style="width: 10%; display: flex; align-items: center; justify-content: center">
				<div style="width: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center">
					<sf-button line class="icon-sf-caret-right" style="margin: 0 0 10px 0" :onClick="onRight" />
					<sf-button line class="icon-sf-caret-left" style="margin: 10px 0 0 0" :onClick="onLeft" />
				</div>
			</div>

			<div style="width: 47%">
				<div class="sf-flex-column h-100">
					<div class="sf-col sf-col-5">
						<sf-card class="p-0 card_bg">
							<part-cku-prvs-popup-d-search ref="partCkuPrvsPopupSearch" :scrId="scrId" :propData="propPartNo" />
						</sf-card>
					</div>
					<div class="sf-col sf-col-20">
						<part-cku-prvs-popup-d-table ref="rightTable" height="60vh" selection :scrId="scrId" :rows="detailPopupList" />
					</div>
				</div>
				<!-- <div class="sf-col sf-col-8">
					<sf-card class="p-0 card_bg">
						<part-cku-prvs-popup-search ref="partCkuPrvsPopupSearch" :scrId="scrId"  />
					</sf-card>
				</div>
				<sf-card style="width: 100%; height: 500px" title="AQ List">
					<part-cku-prvs-d-popup-table ref="aqTable" selection :scrId="scrId" :rows="detailPopupList" />
				</sf-card> -->
				<!-- <part-cku-prvs-d-popup-table ref="aqTable" selection :columns="columns" :rows="pgmQueueMaps" /> -->
			</div>
		</div>
		<!-- <div class="sf-col sf-col-20 grid-wrapper">
				<div style="grid-column: 1/3; grid-row: 1/2">
					<part-cku-prvs-m-popup-table ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId" />
				</div>
				<div style="grid-column: 3/5; grid-row: 1/2">
					<part-cku-prvs-d-popup-table ref="table" @close="close" @reload="reload" @SendData="sendData" :scrId="scrId" />
				</div>
			</div> -->
		<!-- </div> -->
	</sf-modal-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCkuPrvs/store/helpers';

import PartCkuPrvsPopupMSearch from './Search/PartCkuPrvsPopupMSearch.vue';
import PartCkuPrvsPopupMTable from './Table/PartCkuPrvsPopupMTable.vue';
import PartCkuPrvsPopupDSearch from './Search/PartCkuPrvsPopupDSearch.vue';
import PartCkuPrvsPopupDTable from './Table/PartCkuPrvsPopupDTable.vue';
// import { isNull, isUndefined } from '@/utils';
import utils from '@/utils';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { PartCkuPrvsPopupMSearch, PartCkuPrvsPopupMTable, PartCkuPrvsPopupDSearch, PartCkuPrvsPopupDTable },
	data() {
		return {
			show: false,
			propPartNo1: '',
			propPartNo2: ''
		};
	},
	created() {
		//console.clear();
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		title() {
			return this.getMessage_('QWCC001877'); // 항목복사 팝업
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		Refresh() {
			//console.log('Refresh');
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.partCkuPrvsPopupM.searchPopupMList();
		},
		open() {
			this.show = true;
			this.setStatePopupInit_();
		},
		close() {
			this.show = false;
		},
		sendData(sendParam) {
			this.propPartNo1 = sendParam.partNo;
			this.close();
		},
		onRight() {
			if (this.searchPopupDParams.partNo == '') {
				this.$sf_showMessage({
					icon: 'error',
					//title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('QWCC000003')
				}); //좌,우의 품번항목을 먼저 조회해 주시기 바랍니다.
				return;
			}

			const leftTable = this.$refs.leftTable;
			const selectedRows = leftTable.getMstSelectedRows();
			const afterMoveList = this.detailPopupList.slice();

			let copyData = {};
			selectedRows.forEach(selectedRow => {
				// const { partNo, ckuPrvsCd, prvsClCd } = selectedRow;
				let addFlg = false;
				copyData = {
					partNo: this.searchPopupDParams.partNo,
					ckuPrvsCd: selectedRow.ckuPrvsCd,
					prvsClCd: selectedRow.prvsClCd,
					prvsClNm: selectedRow.prvsClNm,
					ckuWayCd: selectedRow.ckuWayCd,
					nrmUplmVal: selectedRow.nrmUplmVal,
					nrmLlmtVal: selectedRow.nrmLlmtVal,
					spcRslt: selectedRow.spcRslt,
					utmCd: selectedRow.utmCd,
					useYn: selectedRow.useYn,
					addYn: 'Y'
				};
				if (Array.isArray(this.detailPopupList) && this.detailPopupList.length === 0) {
					this.detailPopupList.push(copyData);
				} else {
					for (let i = 0; i < this.detailPopupList.length; i++) {
						addFlg = true;
						const s1 = this.detailPopupList[i];
						if (copyData.partNo == s1.partNo && copyData.ckuPrvsCd == s1.ckuPrvsCd && copyData.prvsClCd == s1.prvsClCd) {
							addFlg = false;
							break;
						}
					}
				}

				if (addFlg) {
					this.detailPopupList.push(copyData);
				}
				addFlg = false;
			});
			leftTable.getMstClearSelection();
		},
		onLeft() {
			const rightTable = this.$refs.rightTable;
			const selectedRows = rightTable.getDtlSelectedRows();
			const selectedMaps = this.detailPopupList.slice();
			const mapData = {};
			selectedMaps.forEach((mapData, index) => {
				const { partNo, ckuPrvsCd, prvsClCd, addYn } = mapData;

				if (
					selectedRows.map(selRow => selRow.partNo).includes(partNo) &&
					selectedRows.map(selRow => selRow.ckuPrvsCd).includes(ckuPrvsCd) &&
					selectedRows.map(selRow => selRow.prvsClCd).includes(prvsClCd)
				) {
					if (addYn == 'Y') {
						//추가된 항목만 삭제하기 위함
						delete selectedMaps[index];
					}
				}
			});

			this.setPopupDataList_({ key: 'detailPopupList', value: selectedMaps.filter(mapData => !this.isUndefined(mapData)) });
			rightTable.getDtlClearSelection();
		},
		propPartNo() {
			//console.log('propPartNo1');
		}

		// ,
		// propPartNo2() {
		// 	console.log('propPartNo2');
		// }
	}
};
</script>

<style lang="scss">
.partCkuPrvsPopup {
	.el-dialog__body {
		height: 97% !important;
	}
	.el-dialog.sf-modal .el-dialog__body {
		max-height: unset !important;
	}
}
</style>
